import { useContext } from 'react';
import { useSnapshot } from 'valtio';

import { PortContext } from './PortContext';

export const useFlowPort = () => {
  const portContext = useContext(PortContext);
  const portSnapshot = useSnapshot(portContext);

  return portSnapshot.value;
};
